import "../scss/style.scss";
import { sliders } from "./sliders";

function onSearchKeyUp(evt)
{
	if (evt.key !== "Enter" && evt.code !== "Enter")
		return;

	evt.preventDefault();
	document.getElementById("searchButton").click();
}

function onSearchKeyUpMobile(evt)
{
	if (evt.key !== "Enter" && evt.code !== "Enter")
		return;

	evt.preventDefault();
	document.getElementById("searchButtonMobile").click();
}

function init()
{
    const input = document.getElementById("search");
	input.addEventListener("keyup", onSearchKeyUp);

	const inputMobile = document.getElementById("searchMobile");
	inputMobile.addEventListener("keyup", onSearchKeyUpMobile);
}

sliders();
init();
